<template>
  <div class="notif-settings">
    <el-drawer :visible.sync="drawerVisible" :with-header="false" size="520px" :append-to-body="true">
      <div class="notif-panel">
        <!-- 顶栏 -->
        <div class="notif-panel__top">
          <div class="notif-panel__title">
            <span class="notif-panel__title-main">{{ $t("notifSettings.title") }}</span>
            <span class="notif-panel__title-sub">{{ $t("notifSettings.subtitle") }}</span>
          </div>
          <button type="button" class="notif-panel__close" @click="drawerVisible = false">
            <i class="el-icon-close"></i>
          </button>
        </div>

        <div class="notif-panel__body">
          <!-- 接收方式：邮件/短信由下方每条规则的 Mail / SMS 勾选决定（旧的“渠道”接口后端从未实现，已移除）；
               站内铃铛始终开启 -->
          <section class="notif-section">
            <div class="notif-channel-row notif-channel-row--static">
              <span class="notif-channel-row__icon"><i class="el-icon-bell"></i></span>
              <div class="notif-channel-row__text">
                <div class="notif-channel-row__label">{{ $t("notifSettings.bell") }}</div>
                <div class="notif-channel-row__hint">{{ $t("notifSettings.bellAlways") }}</div>
              </div>
            </div>
            <div v-if="canRules" class="notif-channel-row__hint">
              {{ $t("notifSettings.perRuleNote") }}
              <span v-if="smsPrice" class="vtm-num">(${{ smsPrice }}/SMS)</span>
            </div>
            <!-- 提醒设置按机器所属账号读取，子账号自己的设置不生效 -->
            <div v-else class="notif-channel-row__hint">{{ $t("notifSettings.ownerManaged") }}</div>
          </section>

          <!-- 通知规则（仅授权用户可见） -->
          <section class="notif-section" v-if="canRules" v-loading="rulesLoading">
            <h4 class="notif-section__title">{{ $t("notifSettings.rulesTitle") }}</h4>

            <div v-for="group in ruleGroups" :key="group.key" class="notif-rule-group">
              <div class="notif-rule-group__title">{{ $t(group.labelKey) }}</div>
              <div v-for="row in group.rows" :key="row.wname" class="notif-rule-row">
                <div class="notif-rule-row__top">
                  <span class="notif-rule-row__name">{{ $t("system." + row.wname) }}</span>
                  <el-switch v-model="row.enabled" active-value="1" inactive-value="0"></el-switch>
                </div>
                <div class="notif-rule-row__mid">
                  <el-checkbox v-model="row.email" true-label="1" false-label="0">{{ $t("system.email") }}</el-checkbox>
                  <el-checkbox v-model="row.phone" true-label="1" false-label="0">{{ $t("system.sms") }}</el-checkbox>
                  <el-checkbox v-model="row.self" true-label="1" false-label="0">{{ $t("notifSettings.recipientSelf") }}</el-checkbox>
                  <el-checkbox v-model="row.repair" true-label="1" false-label="0">{{ $t("notifSettings.recipientOperator") }}</el-checkbox>
                </div>
                <div class="notif-rule-row__bottom">
                  <el-button type="text" icon="el-icon-edit-outline" @click="openTemplateDialog(row)">
                    {{ $t("notifSettings.editTemplates") }}
                  </el-button>
                </div>
              </div>
            </div>

            <div class="notif-section__actions">
              <el-button size="small" @click="resetRules">{{ $t("system.reset") }}</el-button>
              <el-button size="small" type="primary" :loading="rulesSaving" @click="saveRules">
                {{ $t("notifSettings.saveRules") }}
              </el-button>
            </div>
          </section>
        </div>
      </div>
    </el-drawer>

    <!-- 模板编辑弹窗：邮件 + 短信合一 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('notifSettings.editTemplates')"
      :visible.sync="templateDialogVisible"
      width="640px"
      custom-class="notif-template-dialog"
    >
      <el-form label-width="110px">
        <el-form-item :label="$t('system.txyw')">{{ $t("system." + (nowRow.wname || "")) }}</el-form-item>

        <el-divider content-position="left">{{ $t("system.email") }}</el-divider>
        <el-form-item :label="$t('system.yjbt')">
          <el-input style="max-width: 260px" v-model="nowRow.emailTitle" :placeholder="$t('system.pyjbt')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('system.yjnr')">
          <el-row :gutter="12">
            <el-col :span="15">
              <el-input
                ref="emailTextarea"
                type="textarea"
                :rows="5"
                v-model="nowRow.emailText"
                :placeholder="$t('system.pyjnr')"
                maxlength="500"
                show-word-limit
              />
            </el-col>
            <el-col :span="9">
              <div class="notif-keywords">
                <div class="notif-keywords__tip">{{ $t("system.djTip") }}</div>
                <button
                  v-for="(item, i) in activeKeywords"
                  :key="'em' + i"
                  type="button"
                  class="notif-keywords__chip"
                  @click="insertVar('email', item.look)"
                >
                  {{ item.look }}
                </button>
              </div>
            </el-col>
          </el-row>
        </el-form-item>

        <el-divider content-position="left">{{ $t("system.sms") }}</el-divider>
        <el-form-item :label="$t('system.dxbt')">
          <el-input style="max-width: 260px" v-model="nowRow.phoneTitle" :placeholder="$t('system.pdxbt')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('system.dxnr')">
          <el-row :gutter="12">
            <el-col :span="15">
              <el-input
                ref="phoneTextarea"
                type="textarea"
                :rows="5"
                v-model="nowRow.phoneText"
                :placeholder="$t('system.pdxnr')"
                maxlength="160"
                show-word-limit
              />
            </el-col>
            <el-col :span="9">
              <div class="notif-keywords">
                <div class="notif-keywords__tip">{{ $t("system.djTip") }}</div>
                <button
                  v-for="(item, i) in activeKeywords"
                  :key="'sm' + i"
                  type="button"
                  class="notif-keywords__chip"
                  @click="insertVar('sms', item.look)"
                >
                  {{ item.look }}
                </button>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="templateDialogVisible = false">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="saveTemplateDialog">{{ $t("common.definite") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { grantedLinks } from "@/utils/navSections";

  export default {
    name: "NotificationSettings",
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        smsPrice: "",

        rulesLoading: false,
        rulesSaving: false,
        tableData: [],
        copyData: [],

        templateDialogVisible: false,
        nowRow: {},

        // 全字典（保存时用于 {token} <-> 【展示文案】互转，与旧 SystemConfig.vue 保持一致）
        keywords: [
          { send: "{nickName}", look: "【" + this.$t("system.nickName") + "】" },
          { send: "{userName}", look: "【" + this.$t("system.userName") + "】" },
          { send: "{orderNo}", look: "【" + this.$t("system.orderNumber") + "】" },
          { send: "{orderPrice}", look: "【" + this.$t("system.orderPrice") + "】" },
          { send: "{productName}", look: "【" + this.$t("system.goodsName") + "】" },
          { send: "{machineName}", look: "【" + this.$t("system.equipmentName") + "】" },
          { send: "{lineNo}", look: "【" + this.$t("system.lineNo") + "】" },
          { send: "{machineNo}", look: "【" + this.$t("system.equipmentNo") + "】" },
          { send: "{machineAddress}", look: "【" + this.$t("system.machineAddress") + "】" },
          { send: "{walletBalance}", look: "【" + this.$t("system.walletBalance") + "】" },
          { send: "{walletEntry}", look: "【" + this.$t("system.walletEntry") + "】" }
        ],
        // 订单模块变量
        ddkeywords: [
          { send: "{nickName}", look: "【" + this.$t("system.nickName") + "】" },
          { send: "{userName}", look: "【" + this.$t("system.userName") + "】" },
          { send: "{orderNo}", look: "【" + this.$t("system.orderNumber") + "】" },
          { send: "{orderPrice}", look: "【" + this.$t("system.orderPrice") + "】" },
          { send: "{productName}", look: "【" + this.$t("system.goodsName") + "】" },
          { send: "{machineName}", look: "【" + this.$t("system.equipmentName") + "】" },
          { send: "{lineNo}", look: "【" + this.$t("system.lineNo") + "】" },
          { send: "{machineNo}", look: "【" + this.$t("system.equipmentNo") + "】" },
          { send: "{machineAddress}", look: "【" + this.$t("system.machineAddress") + "】" }
        ],
        // 机器模块变量
        jqkeywords: [
          { send: "{nickName}", look: "【" + this.$t("system.nickName") + "】" },
          { send: "{userName}", look: "【" + this.$t("system.userName") + "】" },
          { send: "{machineName}", look: "【" + this.$t("system.equipmentName") + "】" },
          { send: "{machineNo}", look: "【" + this.$t("system.equipmentNo") + "】" },
          { send: "{machineAddress}", look: "【" + this.$t("system.machineAddress") + "】" }
        ],
        // 账户模块变量
        zhkeywords: [
          { send: "{nickName}", look: "【" + this.$t("system.nickName") + "】" },
          { send: "{userName}", look: "【" + this.$t("system.userName") + "】" },
          { send: "{orderNo}", look: "【" + this.$t("system.orderNumber") + "】" },
          { send: "{orderPrice}", look: "【" + this.$t("system.orderPrice") + "】" },
          { send: "{walletBalance}", look: "【" + this.$t("system.walletBalance") + "】" }
        ]
      };
    },
    computed: {
      drawerVisible: {
        get() {
          return this.visible;
        },
        set(val) {
          this.$emit("update:visible", val);
        }
      },
      // 是否授予了旧版 /system/config 页面（决定是否展示“通知规则”区块）
      canRules() {
        return grantedLinks(this.$store.state.menuList).has("/system/config");
      },
      activeKeywords() {
        if (this.nowRow.type === 1) return this.ddkeywords;
        if (this.nowRow.type === 3) return this.zhkeywords;
        return this.jqkeywords;
      },
      ruleGroups() {
        return [
          { key: "order", labelKey: "notifSettings.groupOrder", rows: this.tableData.filter(r => r.type === 1) },
          { key: "machine", labelKey: "notifSettings.groupMachine", rows: this.tableData.filter(r => r.type === 2) },
          { key: "account", labelKey: "notifSettings.groupAccount", rows: this.tableData.filter(r => r.type === 3) }
        ].filter(g => g.rows.length);
      }
    },
    watch: {
      visible(val) {
        if (val) {
          if (this.canRules) {
            this.loadSmsPrice();
            this.loadRules();
          }
        }
      }
    },
    methods: {
      // 短信单价（规则里勾选 SMS 时按条计费），非阻塞展示
      loadSmsPrice() {
        let that = this;
        that.$api
          .request(that.$url.Promote.getDictValue, that.$method.get, {
            type: "service_type_amount",
            label: "WALLET_SMS"
          })
          .then(res => {
            if (res.code === 0) {
              try {
                that.smsPrice = parseFloat(res.data[0].value);
              } catch (error) {
                /* ignore */
              }
            }
          })
          .catch(() => {});
      },
      // 拉取 NOTICE 规则（与旧 SystemConfig.vue 数据契约保持一致）
      loadRules() {
        let that = this;
        that.rulesLoading = true;
        that.$api
          .request(that.$url.Promote.get, that.$method.get, { type: "NOTICE" })
          .then(res => {
            that.rulesLoading = false;
            if (res.code === 0) {
              let rows = [];
              for (let i in res.data) {
                res.data[i].emailText = that.filterKey("look", res.data[i].emailText);
                res.data[i].phoneText = that.filterKey("look", res.data[i].phoneText);
                if (!res.data[i].phoneTitle) {
                  res.data[i].phoneTitle = "";
                }
                rows.push({ ...res.data[i], wname: i });
              }
              // 与旧 SystemConfig.vue 一致的固定模块映射：0=订单 1-10=机器 11-13=账户
              let typeByIndex = [1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3];
              rows.forEach((row, idx) => {
                row.type = typeByIndex[idx] !== undefined ? typeByIndex[idx] : row.type;
              });
              that.tableData = rows;
              that.copyData = JSON.parse(JSON.stringify(rows));
            }
          })
          .catch(err => {
            that.rulesLoading = false;
            that.$notify({
              title: that.$t("common.tip"),
              message: err && err.msg,
              type: "error"
            });
          });
      },
      resetRules() {
        this.tableData = JSON.parse(JSON.stringify(this.copyData));
        this.$message.success(this.$t("system.resetSucess"));
      },
      // 保存规则——payload 形状与旧 SystemConfig.vue save2() 完全一致
      saveRules() {
        let that = this;
        that.rulesSaving = true;
        let value = {};
        that.tableData.forEach(item => {
          value[item.wname] = {
            email: item.email,
            emailText: item.emailText,
            emailTitle: item.emailTitle,
            enabled: item.enabled,
            phone: item.phone,
            phoneText: item.phoneText,
            phoneTitle: item.phoneTitle,
            repair: item.repair,
            self: item.self
          };
        });
        for (let i in value) {
          value[i].emailText = that.filterKey("send", value[i].emailText);
          value[i].phoneText = that.filterKey("send", value[i].phoneText);
        }
        that.$api
          .request(that.$url.Promote.save, that.$method.post, {
            type: "NOTICE",
            content: JSON.stringify(value)
          })
          .then(res => {
            that.rulesSaving = false;
            if (res.code === 0) {
              that.$message.success(res.msg);
              that.copyData = JSON.parse(JSON.stringify(that.tableData));
            } else {
              that.$message.warning(res.msg);
            }
          })
          .catch(err => {
            that.rulesSaving = false;
            that.$notify({
              title: that.$t("common.tip"),
              message: err && err.msg,
              type: "error"
            });
          });
      },
      openTemplateDialog(row) {
        this.nowRow = { ...row };
        this.templateDialogVisible = true;
      },
      saveTemplateDialog() {
        let idx = this.tableData.findIndex(r => r.wname === this.nowRow.wname);
        if (idx !== -1) {
          this.$set(this.tableData, idx, {
            ...this.tableData[idx],
            emailTitle: this.nowRow.emailTitle,
            emailText: this.nowRow.emailText,
            phoneTitle: this.nowRow.phoneTitle,
            phoneText: this.nowRow.phoneText
          });
        }
        this.templateDialogVisible = false;
      },
      // 在光标处插入变量（邮件/短信两个文本域各自定位，避免互相干扰）
      insertVar(target, word) {
        let refName = target === "email" ? "emailTextarea" : "phoneTextarea";
        let fieldName = target === "email" ? "emailText" : "phoneText";
        let comp = this.$refs[refName];
        let textarea = comp && comp.$refs && comp.$refs.textarea;
        if (textarea) {
          let cursorPos = textarea.selectionStart;
          let text = this.nowRow[fieldName] || "";
          let textBefore = text.substring(0, cursorPos);
          let textAfter = text.substring(cursorPos);
          this.nowRow[fieldName] = textBefore + word + textAfter;
          this.$nextTick(() => {
            textarea.focus();
            textarea.setSelectionRange(cursorPos + word.length, cursorPos + word.length);
          });
        } else {
          this.nowRow[fieldName] = (this.nowRow[fieldName] || "") + word;
        }
      },
      filterKey(methods, str) {
        let unMethods = methods === "look" ? "send" : "look";
        str = str || "";
        this.keywords.forEach(item => {
          str = str.replace(new RegExp(this.escapeRegExp(item[unMethods]), "g"), item[methods]);
        });
        return str;
      },
      escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }
    }
  };
</script>

<style scoped lang="scss">
  .notif-panel {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: var(--vtm-bg);
  }
  .notif-panel__top {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 16px 18px;
    background: var(--vtm-navy);
    color: #fff;
    flex-shrink: 0;
  }
  .notif-panel__title {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }
  .notif-panel__title-main {
    font-family: var(--vtm-display);
    font-size: 18px;
    font-weight: 600;
  }
  .notif-panel__title-sub {
    font-size: 12px;
    color: #b9c6d3;
  }
  .notif-panel__close {
    border: none;
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
    width: 28px;
    height: 28px;
    border-radius: 7px;
    cursor: pointer;
    flex-shrink: 0;

    &:hover {
      background: rgba(255, 255, 255, 0.22);
    }
  }
  .notif-panel__body {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
  }

  .notif-section {
    margin-bottom: 18px;
    padding: 14px;
    border: 1px solid var(--vtm-line);
    border-radius: var(--vtm-r-md);
    background: var(--vtm-surface);

    &:last-child {
      margin-bottom: 0;
    }
  }
  .notif-section__title {
    margin: 0 0 12px;
    font-family: var(--vtm-display);
    font-size: 13.5px;
    font-weight: 600;
    color: var(--vtm-heading);
  }
  .notif-section__actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid var(--vtm-line);
  }

  .notif-channel-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 4px;
    border-bottom: 1px solid var(--vtm-line);

    &:last-of-type {
      border-bottom: none;
    }
    &--static {
      opacity: 0.85;
    }
  }
  .notif-channel-row__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    flex-shrink: 0;
    border-radius: 9px;
    font-size: 16px;
    background: var(--vtm-well);
    color: var(--vtm-ink-2);

    &--mint {
      background: var(--vtm-mint-soft);
      color: var(--vtm-mint-ink);
    }
    &--info {
      background: var(--vtm-info-soft);
      color: var(--vtm-info);
    }
  }
  .notif-channel-row__text {
    flex: 1;
    min-width: 0;
  }
  .notif-channel-row__label {
    font-size: 13.5px;
    font-weight: 600;
    color: var(--vtm-heading);
  }
  .notif-channel-row__hint {
    font-size: 12px;
    color: var(--vtm-ink-3);
  }

  .notif-rule-group {
    margin-bottom: 14px;

    &:last-child {
      margin-bottom: 0;
    }
  }
  .notif-rule-group__title {
    margin-bottom: 6px;
    font-size: 11.5px;
    font-weight: 600;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: var(--vtm-ink-3);
  }
  .notif-rule-row {
    padding: 10px;
    margin-bottom: 8px;
    border: 1px solid var(--vtm-line);
    border-radius: var(--vtm-r-sm);
    background: var(--vtm-surface-2);

    &:last-child {
      margin-bottom: 0;
    }
  }
  .notif-rule-row__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 6px;
  }
  .notif-rule-row__name {
    font-size: 13px;
    font-weight: 600;
    color: var(--vtm-ink);
  }
  .notif-rule-row__mid {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 14px;
    margin-bottom: 4px;
  }
  .notif-rule-row__bottom {
    text-align: right;
  }

  .notif-keywords {
    padding: 8px;
    border-radius: var(--vtm-r-sm);
    background: var(--vtm-well);
    max-height: 168px;
    overflow-y: auto;
  }
  .notif-keywords__tip {
    margin-bottom: 6px;
    font-size: 11.5px;
    color: var(--vtm-ink-3);
  }
  .notif-keywords__chip {
    display: block;
    width: 100%;
    margin-bottom: 4px;
    padding: 3px 6px;
    border: 1px solid var(--vtm-line);
    border-radius: var(--vtm-r-sm);
    background: var(--vtm-surface);
    color: var(--vtm-mint-ink);
    font-size: 12px;
    text-align: left;
    cursor: pointer;
    transition: border-color var(--vtm-speed) ease, background-color var(--vtm-speed) ease;

    &:hover {
      border-color: var(--vtm-mint-dim);
      background: var(--vtm-mint-soft);
    }
  }
</style>
